import type { Sentence } from "@huosu/shared";
import { safeSentenceStructure, isGrammarRole, normalizeGrammarRole, normalizeContractedGrammar, grammarTokens } from "@huosu/shared";

const tokens = (text: string) => grammarTokens(text).map(word => word.toLowerCase());
const roleColors: Record<string, string> = { 主语: "#b745d7", 谓语: "#8555eb", 宾语: "#e84591", 宾补: "#08a6c6", 表语: "#00a67a", 定语: "#159fdb", 状语: "#e58a00" };

/** One heading per consecutive syntactic phrase, while keeping lexical data per word. */
export function groupStudyWords<T extends { id: string; role: string; color: string }>(words: readonly T[]) {
  const groups: Array<{ id: string; role: string; color: string; words: T[] }> = [];
  for (const word of words) {
    const previous = groups[groups.length - 1];
    if (word.role && previous?.role === word.role) previous.words.push(word);
    else groups.push({ id: word.id, role: word.role, color: word.color, words: [word] });
  }
  return groups;
}

// A lexical category (noun/pronoun) or a container (whole sentence/phrase)
// is not a syntactic function. Never use those as substitute grammar labels.
export function studyGrammarRoles(sentence: Pick<Sentence, "english" | "structure">) {
  const words = tokens(sentence.english);
  const parts = normalizeContractedGrammar(safeSentenceStructure(sentence));
  const aligned = tokens(parts.map((part) => part.text).join(" ")).join(" ") === words.join(" ");
  if (!aligned) return words.map(() => ({ label: "", color: "#60748a" }));
  return parts.flatMap((part) => {
    let label = normalizeGrammarRole(part.label);
    if (!isGrammarRole(label)) label = "";
    const category = Object.keys(roleColors).find((role) => label.includes(role));
    return tokens(part.text).map(() => ({ label, color: category ? roleColors[category] : "#60748a" }));
  });
}
